import * as React from "react"

import Link from "./link"

type Props = {
  children: React.ReactNode
  url: string | null
}

const ArticleLinkable: React.FC<Props> = ({ children, url }) => {
  if (url) {
    return (
      <Link
        href={url}
        external={true}
        sponsored={true}
      >
        {children}
      </Link>
    )
  }
  return (<>{children}</>)
}

export default ArticleLinkable
